export default "__VITE_ASSET__Cd4K7J7h__"